import { Link, Tag, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import type { RelatedDocumentWithLink } from '../../types/relatedDocument'

interface RelatedDocumentLinksProps {
  onDocumentClick?: (document: RelatedDocumentWithLink) => void
  relatedDocuments: RelatedDocumentWithLink[]
}

export const RelatedDocumentLinks = ({
  relatedDocuments,
  onDocumentClick,
}: RelatedDocumentLinksProps): ReactElement | null => {
  const { t } = useTranslation()

  if (!relatedDocuments.length) {
    return null
  }

  const handleLinkClick = (document: RelatedDocumentWithLink) => () => {
    onDocumentClick?.(document)
  }

  return (
    <>
      {relatedDocuments.map((document) => (
        <Text alignment="left" colorVariant="primary" key={document.documentId} variant="bodySM" weight="bold">
          <Link onClick={handleLinkClick(document)} to={document.documentUrl} withAnimation>
            {document.documentName}
          </Link>{' '}
          {document.documentType === InvoiceDocumentType.InvoiceDraft && (
            <Tag color="purple" size="xs" type="subtle">
              {t('external_invoices.related_invoice.draft')}
            </Tag>
          )}
        </Text>
      ))}
    </>
  )
}
